var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3485_6591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.35953 26H7.8745V12.6077L0 6.70605V23.6631C0 24.9557 1.06687 26 2.35953 26Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8047 25.9999H32.3197C33.6377 25.9999 34.6792 24.933 34.6792 23.6404V6.70593L26.8047 12.6076V25.9999Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8047 2.37082V12.6077L34.682 6.70604V3.55059C34.682 0.623754 31.3459 -1.03582 29.0062 0.714071L26.8047 2.37082Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 12.6078V2.37097L17.3413 9.47497L26.8049 2.37097V12.6078L17.3413 19.6893L7.875 12.6078Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.55125V6.7067L7.87733 12.6084V2.37149L5.67585 0.714736C3.33608 -1.03233 0 0.646999 0 3.55125Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3485_6591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6817,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmial);
export default __webpack_public_path__ + "static/media/emial.2c4d89bab90135da4b1f38da380eff4e.svg";
export { ForwardRef as ReactComponent };